import * as Sentry from "@sentry/react";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://dc35a08825bbf364674a20831827e6a2@o4510035461472256.ingest.de.sentry.io/4510035563380816",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/api\.(staging\.)?bonisoft\.de\/api/
    ]
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback="">
      <App />
    </Suspense>
  </React.StrictMode>
);
